module.exports = __webpack_public_path__ + "static/img/02best.e0a47fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/sport/07sportIndex/02best.png
// module id = g41f
// module chunks = 0